import { factory, stateOptions } from '@store/utils'
import { map, prop, propOr } from 'rambda'
import { assignSpec } from '@utils/objects'

const siteSettings = {
  doesSupportChildIds: {
    key: 'doesSupportChildIds',
    label: 'Do pass article child IDs as meta fields?',
    defaultTo: false,
    type: 'checkbox',
  },
  productExportTemplate: {
    key: 'productExportTemplate',
    label: 'Product export template',
    defaultTo: 'LAPTOP_SECTION',
    type: 'select',
    options: [
      { label: 'Laptop (legacy)', value: 'LAPTOP_SECTION' },
      { label: 'Product', value: 'PRODUCT_SECTION' },
    ],
  },
}

export default {
  auto: '*',
  store: {
    state: {
      seoPlugins: [
        {
          label: 'AIOSEO',
          value: 'AIOSEO',
        },
        {
          label: 'YOAST',
          value: 'YOAST',
        },
      ],
    },
    getters: {
      seoPlugins: state => state.seoPlugins,

      formSiteSettings: () => settings => map(
        assignSpec({
          value: ({ defaultTo, key }) => propOr(defaultTo, key, settings),
        }),
        siteSettings,
      ),

      siteFactory: factory(({ authUser }) => ({
        companyId: null,
        userId: authUser?.id || null,
        name: null,
        url: null,
        jwt: null,
        jwtExpiresAt: null,
        tag: null,
      })),
      siteOptions: stateOptions(prop('name')),
    },
  },
}
